import IUpdater from "./updater-interface";

export default class SearchableDecorator extends IUpdater {
    constructor(updater, question) {
        super();

        this._updater = updater;

        question.loadMoreAnswersCompleteEvent.on(() => this.update(question));
        question.filterAnswersCompleteEvent.on(() => this.update(question));
    }

    update(display) {
        this._updater.update(display);
    }
}